export default __webpack_public_path__ + "static/media/030_corner1.first.07d7f267.avif";